import { SortItem } from "@omni/components/components/Search/SearchResults/components/results/components/productsResults/components/resultsView/components/filters/components/productSort/sort.types";
import { cn } from "@omni/utils/styles";

import { ListItemConfig } from "./listItem.config";

const SortListItem = ({ label, value }: SortItem) => {
    const icon = ListItemConfig[value];
    return (
        <>
            <i className={cn(`tw:pr-1 la-lg las ${icon}`)}></i>
            {label}
        </>
    );
};

export { SortListItem };
